import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { FileIcon } from './FileIcon';
import { Globe, Code } from 'lucide-react';

interface DeletedDataSourceItemProps {
    sourceType: string;
    sourceId: string;
    name?: string | null;
    originalMetadata?: {
        url?: string;
        crawl_depth?: number;
        method?: string;
        endpoint?: string;
        mime_type?: string;
    };
}

const DeletedDataSourceItem: React.FC<DeletedDataSourceItemProps> = ({
                                                                         sourceType,
                                                                         sourceId,
                                                                         originalMetadata,
                                                                         name
                                                                     }) => {
    const getIcon = () => {
        switch (sourceType) {
            case 'files':
                return (
                    <FileIcon
                        mimeType={originalMetadata?.mime_type || "text/plain"}
                        size={20}
                        className="text-secondary me-2"
                    />
                );
            case 'websites':
                return <Globe size={16} className="me-2 text-secondary" />;
            case 'apis':
                return <Code size={16} className="me-2 text-secondary" />;
            default:
                return null;
        }
    };

    const getAdditionalInfo = () => {
        switch (sourceType) {
            case 'websites':
                if (originalMetadata?.url) {
                    return (
                        <div className="text-muted small fst-italic">
                            {originalMetadata.url}
                            {originalMetadata.crawl_depth !== undefined &&
                                ` (Depth: ${originalMetadata.crawl_depth})`
                            }
                        </div>
                    );
                }
                break;
            case 'apis':
                if (originalMetadata?.endpoint || originalMetadata?.url) {
                    return (
                        <div className="text-muted small fst-italic">
                            {originalMetadata.endpoint || originalMetadata.url}
                            {originalMetadata.method && ` (${originalMetadata.method})`}
                        </div>
                    );
                }
                break;
            case 'files':
                if (originalMetadata?.mime_type) {
                    return (
                        <div className="text-muted small fst-italic">
                            Type: {originalMetadata.mime_type}
                        </div>
                    );
                }
                break;
        }
        return null;
    };

    return (
        <div className="list-group-item p-2 border-bottom d-flex justify-content-between align-items-center bg-secondary bg-opacity-10">
            <div className="d-flex align-items-center">
                {getIcon()}
                <div>
                    <div className="d-flex align-items-center">
                        <span className="text-secondary fst-italic">
                            {name ? `${name} (orphaned)` : 'Orphaned Source'}
                        </span>
                        <AlertTriangle size={14} className="text-secondary ms-2" />
                    </div>
                    {getAdditionalInfo()}
                    <small className="text-muted fst-italic d-block">
                        ID: {sourceId}
                    </small>
                </div>
            </div>
        </div>
    );
};

export default DeletedDataSourceItem;